import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '速查！你与新冠肺炎确诊患者同行过吗？';

const route: RouteConfig = {
  path: '/20200131SARICX',
  name: '20200131SARICX',
  component: () => import('./Home.vue'),
  meta: {
    title: PAGE_TITLE,
  },
};

export default route;
